import { color, layout } from '../../../GlobalStyles';
import styled from 'styled-components';

const { size1, size2, size3, size4, size6 } = layout;
const { gray1, gray7 } = color;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size6}px;
  margin-top: ${size1}px;
`;

export const Subtitle = styled.span.attrs({ className: 'subtitle-regular' })``;

export const FeaturesList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  color: ${gray7};
  gap: ${size3}px;

  &:not(:first-child) {
    padding-top: ${size4}px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${gray1};
    padding-bottom: ${size4}px;
  }
`;

export const FeatureIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${gray1};
  padding: ${size2}px;
  border-radius: 50%;
`;

export const FeatureText = styled.span.attrs({ className: 'body-regular' })``;
